import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { SITE } from "@/lib/site";

const REVIEWS = [
  {
    name: "Pietro Mulè",
    when: "1 anno fa",
    text: "Auto usate di tutti i tipi, il titolare persona cordiale e gentile.",
  },
  {
    name: "Terra Nostra B&B",
    when: "8 anni fa",
    text: "Ottimi prodotti e massima assistenza.",
  },
  { name: "Giuseppe Enzo Sciortino", when: "3 anni fa", text: null },
  { name: "Francesca Di Mino", when: "5 anni fa", text: null },
  { name: "Enzo Marchetta", when: "6 anni fa", text: null },
];

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 stelle su 5">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="w-3.5 h-3.5 text-amber-500" fill="currentColor" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="recensioni" className="py-12 md:py-16 border-t border-border overflow-hidden" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 mb-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="flex flex-wrap items-end justify-between gap-4"
      >
        <div>
          <p className="font-mono2 text-xs uppercase tracking-[0.35em] text-amber-500 mb-3">Recensioni</p>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight">
            Cosa dicono i clienti
          </h2>
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <a
            data-testid="reviews-google-link"
            href={SITE.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 text-sm text-gray-400 hover:text-amber-500 transition-colors group"
          >
            <img src="https://cdn.simpleicons.org/google" alt="" className="w-4 h-4 opacity-80 group-hover:opacity-100" />
            <span className="flex items-center gap-1.5">
              <span className="font-semibold text-gray-200">4,3</span>
              <Star className="w-3.5 h-3.5 text-amber-500" fill="currentColor" />
              <span>· 19 recensioni su Google</span>
            </span>
          </a>
          <a
            data-testid="reviews-write-btn"
            href={SITE.reviewLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-amber-500/50 text-amber-500 hover:bg-amber-500 hover:text-[#0A0D14] text-sm font-medium px-5 py-2.5 rounded-full transition-all"
          >
            <Star className="w-4 h-4" />
            Lascia una recensione
          </a>
        </div>
      </motion.div>
    </div>

    <div className="relative" data-testid="reviews-marquee">
      <div className="flex w-max animate-marquee" style={{ animationDuration: "65s" }}>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex gap-4 pr-4 shrink-0" aria-hidden={copy === 1}>
            {REVIEWS.map((r, i) => (
              <div
                key={`${copy}-${i}`}
                data-testid={copy === 0 ? `review-card-${i}` : undefined}
                className="w-72 shrink-0 bg-[#111622] border border-border rounded-xl p-5 hover:border-amber-500/30 transition-colors"
              >
                <div className="flex items-center justify-between mb-3">
                  <Stars />
                  <span className="text-[10px] font-mono2 uppercase tracking-widest text-gray-600">{r.when}</span>
                </div>
                {r.text ? (
                  <p className="text-sm text-gray-300 leading-relaxed">“{r.text}”</p>
                ) : (
                  <p className="text-sm text-gray-600 italic">Valutazione 5 stelle</p>
                )}
                <div className="mt-4 flex items-center gap-2.5">
                  <span className="w-8 h-8 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center font-display font-bold text-amber-500 text-sm">
                    {r.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-gray-200">{r.name}</p>
                    <p className="text-[10px] text-gray-600 font-mono2 uppercase tracking-widest">Recensione Google</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#0A0D14] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#0A0D14] to-transparent pointer-events-none" />
    </div>
  </section>
);
